import 'jquery-validation';
import './profile-orders.js';

$(function () {

	/* ======================================================
	   Helper: AJAX küldés egységesen
	   ====================================================== */
	function profileAjax(url, data, $btn, onSuccess, onError) {
		$btn.prop('disabled', true);
		$.ajax({
			url: url,
			method: 'POST',
			data: data,
			dataType: 'json',
			success: function (res) {
				if (res.status === 'success') {
					onSuccess(res);
				} else {
					GlobalSwal.fire({
						title: window.Lang.error_title,
						text: res.message || window.Lang.prof_save_error,
						icon: 'error',
						confirmButtonText: window.Lang.confirm_button
					});
					$btn.prop('disabled', false);
				}
			},
			error: function (xhr) {
				var errors = xhr.responseJSON && xhr.responseJSON.errors;
				var msg = errors
					? Object.values(errors).flat().join('\n')
					: (xhr.responseJSON && xhr.responseJSON.message) || window.Lang.prof_save_error;

				if (onError) {
					onError(msg);
				} else {
					GlobalSwal.fire({
						title: window.Lang.error_title,
						text: msg,
						icon: 'error',
						confirmButtonText: window.Lang.confirm_button
					});
				}
				$btn.prop('disabled', false);
			}
		});
	}

	/* ======================================================
	   1. Személyes adatok form
	   ====================================================== */
	if ($('#profilePersonalForm').length) {
		$('#profilePersonalForm').validate({
			rules: {
				last_name: { required: true, maxlength: 100 },
				first_name: { required: true, maxlength: 100 },
				email: { required: true, email: true },
				phone: { required: false }
			},
			messages: {
				last_name: {
					required: window.Lang.prof_val_last_name
				},
				first_name: {
					required: window.Lang.prof_val_first_name
				},
				email: {
					required: window.Lang.val_email_required,
					email: window.Lang.val_email_invalid
				}
			},
			errorElement: 'span',
			errorClass: 'text-danger small',
			submitHandler: function (form) {
				var $form = $(form);
				var $btn = $form.find('[type="submit"]');

				profileAjax(
					$form.attr('action'),
					$form.serialize(),
					$btn,
					function () {
						GlobalSwal.fire({
							title: window.Lang.success_title,
							text: window.Lang.prof_save_success,
							icon: 'success',
							confirmButtonText: window.Lang.confirm_button
						});
						$btn.prop('disabled', false);
					}
				);
			}
		});
	}

	/* ======================================================
	   2. Cím form
	   ====================================================== */
	if ($('#profileAddressForm').length) {
		$('#profileAddressForm').validate({
			rules: {
				delivery_country_code: { required: true },
				delivery_zip: { required: true, maxlength: 20 },
				delivery_city: { required: true, maxlength: 100 },
				delivery_street: { required: true, maxlength: 255 },
				delivery_house_number: { required: true, maxlength: 50 }
			},
			messages: {
				delivery_street: { required: window.Lang.prof_val_address },
				delivery_house_number: { required: window.Lang.prof_val_address },
				delivery_zip: { required: window.Lang.prof_val_zip },
				delivery_city: { required: window.Lang.prof_val_city }
			},
			errorElement: 'span',
			errorClass: 'text-danger small',
			submitHandler: function (form) {
				var $form = $(form);
				var $btn = $form.find('[type="submit"]');

				profileAjax(
					$form.attr('action'),
					$form.serialize(),
					$btn,
					function () {
						GlobalSwal.fire({
							title: window.Lang.success_title,
							text: window.Lang.prof_save_success,
							icon: 'success',
							confirmButtonText: window.Lang.confirm_button
						});
						$btn.prop('disabled', false);
					}
				);
			}
		});
	}

	/* ======================================================
	   3. Jelszó módosítás form
	   ====================================================== */
	if ($('#profilePasswordForm').length) {
		$.validator.addMethod('passwordStrength', function (value) {
			return /[a-z]/.test(value)
				&& /[A-Z]/.test(value)
				&& /[0-9]/.test(value)
				&& /[^a-zA-Z0-9]/.test(value);
		}, window.Lang.val_password_strength);

		$('#profilePasswordForm').validate({
			rules: {
				current_password: { required: true },
				password: {
					required: true,
					minlength: 8,
					passwordStrength: true
				},
				password_confirmation: {
					required: true,
					equalTo: '#profileNewPassword'
				}
			},
			messages: {
				current_password: {
					required: window.Lang.prof_val_old_password
				},
				password: {
					required: window.Lang.val_password_required,
					minlength: window.Lang.val_password_minlength,
					passwordStrength: window.Lang.val_password_strength
				},
				password_confirmation: {
					required: window.Lang.val_pw_confirm_required,
					equalTo: window.Lang.val_pw_confirm_mismatch
				}
			},
			errorElement: 'span',
			errorClass: 'text-danger small',
			submitHandler: function (form) {
				var $form = $(form);
				var $btn = $form.find('[type="submit"]');

				profileAjax(
					$form.attr('action'),
					$form.serialize(),
					$btn,
					function () {
						$form[0].reset();
						GlobalSwal.fire({
							title: window.Lang.success_title,
							text: window.Lang.prof_pw_save_success,
							icon: 'success',
							confirmButtonText: window.Lang.confirm_button
						});
						$btn.prop('disabled', false);
					},
					function (msg) {
						GlobalSwal.fire({
							title: window.Lang.error_title,
							text: msg,
							icon: 'error',
							confirmButtonText: window.Lang.confirm_button
						});
					}
				);
			}
		});
	}

	/* ======================================================
	   4. Fiók törlése
	   ====================================================== */
	$(document).on('click', '#profileDeleteBtn', function () {
		var url = $(this).data('url');
		var $btn = $(this);

		GlobalSwal.fire({
			title: window.Lang.prof_delete_title,
			text: window.Lang.prof_delete_text,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: window.Lang.prof_delete_confirm,
			cancelButtonText: window.Lang.prof_delete_cancel
		}).then(function (result) {
			if (!result.isConfirmed) return;

			profileAjax(
				url,
				{ _token: $('meta[name="csrf-token"]').attr('content') },
				$btn,
				function (res) {
					GlobalSwal.fire({
						title: window.Lang.success_title,
						text: res.message,
						icon: 'success',
						confirmButtonText: window.Lang.confirm_button
					}).then(function () {
						window.location.reload();
					});
				}
			);
		});
	});

	/* ======================================================
	   5. Fiók törlés visszavonása
	   ====================================================== */
	$(document).on('click', '#profileCancelDeleteBtn', function () {
		var url = $(this).data('url');
		var $btn = $(this);

		GlobalSwal.fire({
			title: window.Lang.prof_cancel_delete_title,
			text: window.Lang.prof_cancel_delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonText: window.Lang.prof_cancel_delete_confirm,
			cancelButtonText: window.Lang.prof_delete_cancel
		}).then(function (result) {
			if (!result.isConfirmed) return;

			profileAjax(
				url,
				{ _token: $('meta[name="csrf-token"]').attr('content') },
				$btn,
				function (res) {
					GlobalSwal.fire({
						title: window.Lang.success_title,
						text: res.message,
						icon: 'success',
						confirmButtonText: window.Lang.confirm_button
					}).then(function () {
						window.location.reload();
					});
				}
			);
		});
	});

});
